module.exports = __webpack_public_path__ + "img/nav4.ad31436f.svg";